import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { ORG } from "../data/siteData";

const LINKS = [
  { label: "Início", href: "#hero", testid: "nav-link-hero" },
  { label: "Quem Somos", href: "#sobre", testid: "nav-link-sobre" },
  { label: "Transparência", href: "#transparencia", testid: "nav-link-transparencia" },
  { label: "Galeria", href: "#galeria", testid: "nav-link-galeria" },
  { label: "Contato", href: "#contato", testid: "nav-link-contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0F0F11]/85 border-b border-white/10" data-testid="navbar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3" data-testid="nav-brand">
          <img src={`${process.env.PUBLIC_URL}/assets/logo-amacli.png`} alt="Logo AMACLI" className="h-10 w-10 object-contain" />
          <div className="leading-tight">
            <span className="block font-heading font-bold text-[#F8FAF8] tracking-wide">AMACLI</span>
            <span className="block text-[10px] text-zinc-400 uppercase tracking-widest">Judô Itakira</span>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-6">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} className="text-sm text-zinc-300 hover:text-white transition-colors duration-200">
              {l.label}
            </a>
          ))}
          <a href="#contato" data-testid="nav-cta-whatsapp" className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#EF4444] text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors duration-200">
            <MessageCircle className="h-4 w-4" /> Falar no WhatsApp
          </a>
        </nav>
        <button className="md:hidden text-zinc-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Abrir menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-white/10 bg-[#0F0F11] px-4 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`${l.testid}-mobile`} onClick={() => setOpen(false)} className="text-sm text-zinc-200 py-1">
              {l.label}
            </a>
          ))}
          <a href="#contato" data-testid="nav-cta-whatsapp-mobile" onClick={() => setOpen(false)} className="inline-flex items-center gap-2 bg-[#DC2626] text-white text-sm font-semibold px-4 py-2 rounded-full w-fit">
            <MessageCircle className="h-4 w-4" /> Falar no WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
};
